import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import HowDidYouHearAboutUs from './how-did-you-hear-about-us'

const howDidYouHearAboutUsRoutes: Route[] = [
  {
    path: Paths.SETTING_HOW_DID_YOU_HEAR_ABOUT_US,
    element: <HowDidYouHearAboutUs />,
    roles: [RoleEnum.ADMIN]
  }
]

export default howDidYouHearAboutUsRoutes
